module.exports = __webpack_public_path__ + "static/media/sofa-2.9dce23aa.webp";